//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//

/**
 * Internal class representing an AddressEntry in the Addresses array in the DGI v1 grammar.
 */
export interface AddressEntry {
    /**
     * Gets an Address in the Addresses array
     */
    address: string;
}
